import { useServices } from "@/services/hooks/useServices";
import {
  ITourProgressResponse,
  OnboardingQnAData,
} from "@/types/organisation.types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useOnboardingQnA = () => {
  const { organisationService } = useServices();

  return useMutation({
    mutationFn: (qna: OnboardingQnAData) =>
      organisationService.onboardingQnA({
        qna,
      }),
  });
};

export const useOnboardMember = (enabled: boolean = true) => {
  const { memberService } = useServices();

  return useQuery({
    queryKey: ["onboardMember"],
    queryFn: () => memberService.onboardMember(),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export const useFetchOnboardingStatus = () => {
  const { organisationService } = useServices();

  return useQuery({
    queryKey: ["onboarding-status"],
    queryFn: () => organisationService.fetchOnboardingStatus(),
    // one time fetch
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};
export const useTourProgress = () => {
  const { organisationService } = useServices();

  return useQuery({
    queryKey: ["tour-progress"],
    queryFn: () => organisationService.fetchTourProgress(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};
export const useUpdateTourStep = () => {
  const { organisationService } = useServices();

  return useMutation({
    mutationFn: (data: { step: number; action: "complete" | "skip" }) =>
      organisationService.updateTourStep(data),
  });
};
export const useSeenWelcomePopup = () => {
  const { organisationService } = useServices();

  return useMutation({
    mutationFn: () => organisationService.seenWelcomePopup(),
  });
};

export const useDismissTour = () => {
  const { organisationService } = useServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => organisationService.dismissTour(),
    onSuccess: () => {
      // Update the tour progress cache to reflect the dismissal
      queryClient.setQueryData(
        ["tour-progress"],
        (old: ITourProgressResponse | undefined) => {
          if (!old) return old;
          return {
            ...old,
            isTourDismissed: true,
          };
        }
      );
    },
  });
};

export const usePageGuideVisit = () => {
  const { organisationService } = useServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (page: string) => organisationService.pageGuideVisit({ page }),
    onSuccess: (data: ITourProgressResponse["pageGuideVisits"]) => {
      queryClient.setQueryData(
        ["tour-progress"],
        (old: ITourProgressResponse) => {
          console.log("old from hook", old);

          return {
            ...old,
            pageGuideVisits: data,
          };
        }
      );
      console.log("from hook", data);
    },
  });
};
